/* Manages the global modal component. */

export const chirpModal = {
  initialized: false,

  init() {
    this.initialized = true;
    if ($('#modal').hasClass('active')) {
      this.showModal();
    }

    // Use the '.close' class to hide the modal
    $('#modal .close').on('click touch', this.hideModal.bind(this));
  },

  showModal() {
    if (this.initialized) {
      $('body').addClass('modal-open');
      $('#modal').removeClass('hidden').addClass('active');
    }
  },

  hideModal() {
    if (this.initialized) {
      $('body').removeClass('modal-open');
      $('#modal').removeClass('active').addClass('hidden');
    }
  },
};
